import { render } from "./CoursesItems.vue?vue&type=template&id=6e3a3cd8"
import script from "./CoursesItems.vue?vue&type=script&lang=js"
export * from "./CoursesItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__